module.exports = __webpack_public_path__ + "static/39import-0d1c20a2228c6ef45cbcc1ff44908d9e.png";